import { Grid, Link, Typography } from "@material-ui/core";
import { Cancel } from "@material-ui/icons";
import { useDispatch, useSelector } from "react-redux";
import { showSnackbar } from "../../../Components/Snackbar/SnackbarActions";
import { GLOBAL_STEPPER_DATA } from "../../../Redux/actions";
import AdminPartnerClient from "../../../Service/Admin/partner_services";
import moment from 'moment';

export const setCompDataArr = (dataArr, setData, data) => {
    var localArr = [];
    dataArr.map((option) => {
        (localArr.push(option.value))
    })
    data.length = 0;
    setData(data.concat(localArr))
}
export const getSelectedIdFromArr = (dataArr, value) => {
    console.log(dataArr.length, value)
    if (dataArr.length > 0) {
        const localArr = dataArr.filter((option) => {
            if (option.value == value) {
                return option
            }
        })
        console.log("localArr", localArr)
        return localArr.length > 0 ? localArr[0].id : '[]'
    } else {
        return '[]'
    }
}
export const getValueFromArrById = (dataArr, id) => {

    if (dataArr.length > 0) {
        const localArr = dataArr.filter((option) => {
            if (option.id == id) {
                return option
            }
        })
        return localArr.length > 0 ? localArr[0].value : 0
    } else {
        return 0
    }
}

export const getValueFromArrayForCombobox = (outerArr, innerArr, setKey, key, dispatch, type) => {

    if (outerArr.length > 0) {
        var localOuterArr = [], localSetKey = [];
        outerArr.map((languages_id) => {
            var localInnerArr = [];
            localInnerArr = innerArr.filter((roleOption) => roleOption.id == languages_id)
            localOuterArr.push(localInnerArr[0])
        })
        localOuterArr.map((option) => {
            localSetKey.push(option.value)
            if (type == "role") {
                console.log(`option.value-------`, option.value)
                // dispatch({ type: GLOBAL_STEPPER_DATA, payload: { facilitation_flag: false, mentoring_flag: false, coach_flag: false, assessor_flag: false } });
                option.value == "Facilitator" && dispatch({ type: GLOBAL_STEPPER_DATA, payload: { facilitation_flag: true } });
                option.value == "Mediator" && dispatch({ type: GLOBAL_STEPPER_DATA, payload: { mentoring_flag: true } });
                option.value == "Executive Coach" && dispatch({ type: GLOBAL_STEPPER_DATA, payload: { coach_flag: true } });
                option.value == "Assessor" && dispatch({ type: GLOBAL_STEPPER_DATA, payload: { assessor_flag: true } });
            }
        })
        key.length = 0;
        setKey(key.concat(localSetKey))
        // setTimeout(() => {
        // }, 1000);
    }
}

// StepperService.getValueFromArrayForCombobox(response.data.attributes.partner_languages, global_data_common.partnerDropdowns[mappedKeyJSON.Language], setLanguages_attribute, languages_attribute)


export const getValueFromArrayForCombobox1 = (outerArr, innerArr, setKey, key, dispatch, type, global_data) => {
    if (outerArr && outerArr[0] != null && outerArr.length > 0) {
        var localOuterArr = [], localSetKey = [];
        outerArr.map((languages_id) => {
            var localInnerArr = [];
            localInnerArr = innerArr.filter((roleOption) => roleOption.id == languages_id)
            localOuterArr.push(localInnerArr[0])
        })
        // type == "role" && dispatch({ type: GLOBAL_STEPPER_DATA, payload: { facilitation_flag: false, mentoring_flag: false, coach_flag: false, assessor_flag: false } });
        var pdata = { facilitation_flag: false, mentoring_flag: false, coach_flag: false, assessor_flag: false };
        console.log(`global_data`, global_data)
        localOuterArr.length > 0 && localOuterArr.map((option, index) => {
            console.log(`type,option`, type, option)
            if (type == "role") {
                if (option != undefined) {
                    option?.value == "Facilitator" && (pdata['facilitation_flag'] = true);
                    option?.value == "Mentor" && (pdata['mentoring_flag'] = true);
                    option?.value == "Executive Coach" && (pdata['coach_flag'] = true);
                    option?.value == "Assessor" && (pdata['assessor_flag'] = true);
                } else {
                    pdata = { facilitation_flag: global_data.facilitation_flag, mentoring_flag: global_data.mentoring_flag, coach_flag: global_data.coach_flag, assessor_flag: global_data.assessor_flag };

                }
            }
        })
        console.log(`pdata`, pdata)
        type == "role" && dispatch({ type: GLOBAL_STEPPER_DATA, payload: pdata });

        key.length = 0;
        setKey(key.concat(localOuterArr))
        // setTimeout(() => {
        // }, 1000);
    }
}

const deleteUploadedImageCard = (e, index, arr, setObjArr, objArr) => {
    e.stopPropagation();
    var local = arr.filter((option) => option.id != index)
    objArr.length = 0;
    setObjArr(objArr.concat(local));
}

export const deleteCard = (e, index, arr, setArr, url, dispatch) => {
    console.log(`object`, e, index, arr, setArr)
    AdminPartnerClient.profileDoc_del(index, url).then((response) => {
        dispatch(showSnackbar("Success", ["File removed successfully"]))

    });
    var local = arr.filter((option) => option.attributes.id != index)
    arr.length = 0;
    return setArr(arr.concat(local));
}

export const uploadImageCard = (objArray, setObjArray, url, parentCall, dispatch) => {
    // console.log(objArray)
    return objArray.length > 0 ?
        <Grid container direction="row" alignItems="flex-start" spacing={2}>
            {
                objArray.map((option, index) => <Grid item xs={4} style={{ position: "relative", margin: 8 }}>
                    <Link href={option.attributes.url} target="_blank" style={{ cursor: "pointer" }}>
                        <div style={{ width: "100%", backgroundColor: "#ddd", margin: 10, borderRadius: 5 }}>
                            <div style={{ position: "relative", padding: 10, width: "100%", }}>
                                {
                                    option.attributes.created_at != null &&
                                    <Typography noWrap variant="h5" style={{ color: "#232323", fontSize: 12 }}>{moment(option.attributes.created_at.split("T")[0]).format("DD/MM/YYYY")}</Typography>
                                }
                                <Typography noWrap variant="h5" title={option.attributes.file_name} style={{ color: "#232323", fontSize: 12, textDecoration: "none", paddingRight: 20 }}>{option.attributes.file_name}</Typography>
                            </div>
                        </div>
                    </Link>
                    <Cancel onClick={(e) => { deleteCard(e, option.attributes.id, objArray, setObjArray, url, dispatch); }} style={{ marginRight: 10, position: "absolute", top: 10, right: -20, color: "#232323", fontSize: 16, cursor: "pointer" }} />
                </Grid>)
            }
        </Grid>
        : null

}


const StepperService = {
    setCompDataArr, getSelectedIdFromArr, getValueFromArrById, getValueFromArrayForCombobox, getValueFromArrayForCombobox1, deleteUploadedImageCard,
    uploadImageCard
}


export default StepperService;